import { AuthUserHook } from "@/models/Hooks.ts";

import { useAuthStore } from "@/stores/authStore.ts";

const useAuth = (): AuthUserHook => {
    const { user: authUser, userEmail: email, isAdmin } = useAuthStore();

    return {
        authUser,
        email,
        isAdmin,
    };
};

export default useAuth;
